import * as React from 'react'
import { TouchableOpacity, Text, ScrollView } from 'react-native'
import styled from '@theme/styled-components'

interface Props {
  data: TabOption[]
  equalTabs?: boolean
  isBig?: boolean
  onItemSelected: (opt: TabOption) => void
  value?: TabOption
  disabled?: boolean
}

const Tabs = ({ data, equalTabs = true, isBig = false, onItemSelected, value, disabled }: Props) => {
  return (
    <ScrollView showsHorizontalScrollIndicator={false} horizontal>
      {data.map((d) => {
        const selected = !!value && value.value === d.value
        return (
          <Tab
            disabled={disabled}
            key={d.value}
            equalTabs={!isBig && equalTabs}
            isBig={isBig}
            selected={selected}
            activeOpacity={0.9}
            onPress={() => onItemSelected(d)}>
            <TabText isBig={isBig} selected={selected}>
              {d.label}
            </TabText>
          </Tab>
        )
      })}
    </ScrollView>
  )
}

export default Tabs

const Tab = styled(TouchableOpacity)<{ equalTabs: boolean; selected: boolean; isBig: boolean }>`
  ${(props) => (props.equalTabs ? `flex: 1;` : `margin-right: ${props.isBig ? 24 : 16}px;`)}
  align-items: center;
  border: 0 solid ${(props) => props.theme.colors.primary};
  border-bottom-width: ${(props) => (props.selected ? 2 : 0)}px;
  padding: 0 5px;
  justify-content: center;
`

const TabText = styled(Text)<{ selected: boolean; isBig: boolean }>`
  ${(props) => (props.isBig ? props.theme.fonts.Title3 : props.theme.fonts.Caption1)};
  color: ${(props) =>
    props.selected
      ? props.isBig
        ? props.theme.colors.primaryText
        : props.theme.colors.primary
      : props.theme.colors.secondaryText};
  padding: 6px 0;
  text-align: center;
`
